import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "../pages/student/SideMenu";
import Loader from "../components/loader";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";

import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import SessionPopup from "./SessionPopup";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";


let { lambda, appname } = window.app

const TransactionList = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    const [transactions, setTransactions] = useState([]);

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    // const [sortDirection, setSortDirection] = useState('asc');
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);
    const [usersearch, setUserSearch] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [totalRows, setTotalRows] = useState(0);
    // true when the API paged the result; false when it sent every row (table then pages client-side)
    const [serverPaging, setServerPaging] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [activeFilters, setActiveFilters] = useState(null); // search/date filters the loaded rows belong to
    const requestIdRef = useRef(0);

    // const [isLoading, setIsLoading] = useState(false); 
    const { isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, currentPage, setcurrentPage, data, setData, route, setRoute, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    // single fetch for the transaction list and search/date filters
    const fetchTransactionHistory = async ({ page = 1, perPage: size = perPage, filters = null, showLoader = true } = {}) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true)
        try {
            const response = await tmdbApi.fetchTransactionHistory({ ...filters, paginate: true, pageNumber: page, pageSize: size });
            // a newer request went out while this one was in flight - drop this response
            if (requestId !== requestIdRef.current) return;
            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
            } else {
                const result = response?.result;
                // paged response is { data, totalCount }; a plain array means the API sent every row
                const backendPaged = !Array.isArray(result);
                const rows = (backendPaged ? result?.data : result) ?? [];

                // page is past the end - step back one page
                if (backendPaged && rows.length === 0 && page > 1) {
                    setPage(page - 1)
                    fetchTransactionHistory({ page: page - 1, perPage: size, filters, showLoader })
                    return
                }

                setTransactions(rows);
                setData(rows);
                setServerPaging(backendPaged);
                setTotalRows(backendPaged ? (result?.totalCount ?? rows.length) : rows.length);
                setActiveFilters(filters);
            }
        } catch (err) {
            if (requestId !== requestIdRef.current) return;
            setTableErrMsg(true);
        }
        if (requestId === requestIdRef.current) {
            setIsLoading(false);
            setTableLoading(false);
        }
    };



    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    const keyForRerender = `${perPage}_${data?.length}`;
    // Transaction columns
    const columns = [


        {
            name: 'User Name',
            selector: row => row?.username ?? row?.name ?? '',
            sortable: true,
        },
        {
            name: 'Email ID',
            selector: row => row?.emailid ?? row?.emailid ?? '',
            sortable: true,
        },
        {
            name: 'Transaction ID',
            selector: row => row?.transactionId ?? row?._id ?? '',
            sortable: true,
        },
        {
            name: 'Transaction Type',
            selector: row => row?.transactionType ?? row?._id ?? '',
            sortable: true,
        },
        // {
        //     name: 'Item Type',
        //     selector: row => row?.userName ?? row?.name ?? '',
        //     sortable: true,
        // },
        {
            name: 'Amount',
            selector: row => row?.amount ?? row?.price ?? '',
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row?.date ?? row?.created,
            sortable: true,
            cell: (props) => props?.date ? dateFormat(props?.date) : (props?.created ? dateFormat(props?.created) : ''),
        },
        {
            name: 'Status',
            selector: row => row?.status ?? '',
            sortable: true,
        },
    ];

    const dateFormat = (created) => {
        const date = new Date(created);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };




    useEffect(() => {
        setData([]);
        fetchTransactionHistory({ page: 1 });
    }, []);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }



    const handleChange = (e) => {
        if (e.target.value === "") {
            //   transactionInfo();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            handleDateSearch(e);
        }
    };




    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }




    // exportToExcel(modifiedArray, "data");


    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        console.log('data22222--->', data)
    }

    const clearSearch = () => {
        GetTimeActivity()
        setStartDate(null);
        setEndDate(null);
        setUserSearch("");
        setFlag(false);
        setPage(1);
        fetchTransactionHistory({ page: 1 });
    }

    const handlePageChange = (newPage) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (newPage === page) return;
        GetTimeActivity()
        setPage(newPage);
        if (serverPaging) {
            fetchTransactionHistory({ page: newPage, filters: activeFilters, showLoader: false });
        }
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === perPage) return;
        GetTimeActivity()
        setPerPage(newPerPage);
        setPage(1);
        if (serverPaging) {
            fetchTransactionHistory({ page: 1, perPage: newPerPage, filters: activeFilters, showLoader: false });
        }
    };
    // const handleDateSearch = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);
    //     try {
    //         let params = {};
    //         if (usersearch) params.search = usersearch;
    //         if (startDate) params.searchedFrom = moment(startDate).format("YYYY-MM-DD");
    //         if (endDate) params.searchedTo = moment(endDate).format("YYYY-MM-DD");
    //         let response = await tmdbApi.fetchTransactionHistory(params);
    //         if (response?.result === "Invalid token or Expired") {
    //             // localStorage.clear();
    //             // navigate("/");
    //              setShowSessionPopupup(true)
    //         } else {
    //             setTransactions(response?.result ?? []);
    //             setData(response?.result ?? []);
    //         }
    //     } catch (err) {
    //         console.log(err);
    //         setTableErrMsg(true);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }

    const handleDateSearch = async (e) => {
        e.preventDefault();

        const inputQuery = usersearch;

        // ✅ Validate: block only when NOTHING is provided
        if (
            inputQuery.trim().length === 0 &&
            !startDate &&
            !endDate
        ) {
            toast.error("Search field cannot be empty.");
            return;
        }

        const params = {};

        if (inputQuery.trim().length > 0) {
            params.search = inputQuery.trim();
        }

        if (startDate) {
            params.searchedFrom = moment(startDate).format("YYYY-MM-DD");
        }

        if (endDate) {
            params.searchedTo = moment(endDate).format("YYYY-MM-DD");
        }

        setFlag(true);
        setPage(1);
        fetchTransactionHistory({ page: 1, filters: params });
    };


    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper" className="transactionList-mod-res transactionList-db-res">
                <Header />
                <SideMenu />

                {/* Start right Content here  */}

                <div className="main-content user-management transctions-table" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">Transactions</h4>
                                        </div>

                                        {/* <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser} id="add-user-btn">
                                                ADD USER
                                            </button>
                                        </div> */}


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> : <>
                                                <div className="row mb-2" id="table-header-row">
                                                    <div className="col-sm-4 button-block" id="button-block">
                                                        <div className="dataTables_length" id="datatable-length">

                                                            {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                          onClick={handleExport} id="export-btn">
                          <span className="material-icons">north_east</span>Export
                      </button> */}


                                                        </div>
                                                    </div>
                                                    <div className="col-sm-8 search-input-mob-res">
                                                        <div className="search-box mb-2 d-inline-block" id="search-box">
                                                            <div className="d-flex me-2 search-se-mod-resp">
                                                                <div className="d-flex flex-column flex-grow-1">

                                                                    <div className="d-flex">
                                                                        <div className="position-relative mb-2">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control user-name-input"
                                                                                value={usersearch}
                                                                                onChange={(e) => handleChange(e)}
                                                                                placeholder="Search by User Name"
                                                                                onKeyPress={handleKeypress}
                                                                                id="search-input"
                                                                            />
                                                                        </div>
                                                                        <div className="start-end-mod-resp">
                                                                            <DatePicker
                                                                                selected={startDate}
                                                                                onChange={(date) => setStartDate(date)}
                                                                                selectsStart
                                                                                startDate={startDate}
                                                                                endDate={endDate}
                                                                                placeholderText="Start Date"
                                                                                className="form-control me-2 start-date"
                                                                                dateFormat="yyyy-MM-dd"
                                                                                isClearable
                                                                            />
                                                                            <DatePicker
                                                                                selected={endDate}
                                                                                onChange={(date) => setEndDate(date)}
                                                                                selectsEnd
                                                                                startDate={startDate}
                                                                                endDate={endDate}
                                                                                minDate={startDate}
                                                                                placeholderText="End Date"
                                                                                className="form-control me-2 end-date"
                                                                                dateFormat="yyyy-MM-dd"
                                                                                isClearable
                                                                            />
                                                                            <div className="dataTables_length search-mob-input-res" id="datatable-length-reset">
                                                                                <button
                                                                                    className="fill_btn search-trans-btn"
                                                                                    onClick={(e) => handleDateSearch(e)}
                                                                                    id="search-btn"
                                                                                >
                                                                                    <span className="material-icons search-icon">search</span>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div>
                                                                {/* <div className="dataTables_length search-mob-input-res-1" id="datatable-length-reset">
                                                                    <button
                                                                        className="fill_btn search-trans-btn"
                                                                        onClick={(e) => handleDateSearch(e)}
                                                                        id="search-btn"
                                                                    >
                                                                        <span className="material-icons search-icon">search</span>
                                                                    </button>
                                                                </div> */}
                                                                <div className="dataTables_length" id="datatable-length-reset">
                                                                    <button
                                                                        className="fill_btn"
                                                                        onClick={clearSearch}
                                                                        id="reset-btn">
                                                                        <span className="material-icons-outlined">sync</span>Reset
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="text-sm-end" id="text-end"></div>
                                                    </div>
                                                </div>

                                                <DataTable
                                                    key={keyForRerender}
                                                    columns={columns}
                                                    keyField='_id'
                                                    data={data}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    paginationServer={serverPaging}
                                                    responsive
                                                    persistTableHead
                                                    striped
                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={totalRows}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={perPage}
                                                    paginationDefaultPage={page}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                    sortFunction={customSort}
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}
                                                    progressPending={tableLoading}
                                                    progressComponent={<TableLoader />}
                                                    id="data-table"
                                                />
                                            </>}


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>

                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />



                    <Footer id="footer" />
                </div>




            </div>
        </>
    );
};

export default TransactionList;